var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-panel', [_c('v-tabs', {
    attrs: {
      "tabs": _vm.tabs,
      "selected": _vm.$route.path
    },
    on: {
      "click": function($event) {
        _vm.$router.push($event)
      }
    }
  })], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a13b9650","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/NavigationTabs/NavigationTabs.vue
// module id = 1196
// module chunks = 0